export const FEATURE_CORA = 'cora'
export const FEATURE_SIMPLE_COURSE_CREATE = 'simple-course-create'
export const FEATURE_USER_PROFILE = 'user-profile'
export const FEATURE_PRODUCT_TOUR = 'product-tour-overview'
export const FEATURE_GUEST_APP = 'guest-app-onboarding'
export const FEATURE_AYS_LAUNCH = 'ays-launch'
export const FEATURE_CINDERELLA = 'cinderella'
export const FEATURE_COURSE_QUESTIONS = 'course-questions'
export const FEATURE_SCHEDULE_MOVE_IT = 'schedule-move-it'
